import createVueComponent from '../createVueComponent';

const StarHalf = createVueComponent('StarHalfIcon', [
  ['path', { d: 'M12 17.8 5.8 21 7 14.1 2 9.3l7-1L12 2', key: 'nare05' }],
]);

export default StarHalf;
